//CompareModal.tsx
import React from 'react'
import { Modal, Typography, Tag, Divider, Button } from 'antd'

const { Text } = Typography

interface CompareResponse {
  better_model: string
  reason: string
}

interface CompareModalProps {
  visible: boolean
  result: CompareResponse | null
  onClose: () => void
}

const CompareModal: React.FC<CompareModalProps> = ({ visible, result, onClose }) => {
  return (
    <Modal
      title="Comparison Result"
      visible={visible}
      onCancel={onClose}
      footer={[
        <Button key="close" onClick={onClose}>
          Close
        </Button>,
      ]}
    >
      {result ? (
        <div>
          <Text strong>Better Model: </Text>
          <Tag color="blue">{result.better_model}</Tag>
          <Divider />
          <Text strong>Reason:</Text>
          <p>{result.reason}</p>
        </div>
      ) : (
        <Text>No comparison data available.</Text>
      )}
    </Modal>
  )
}

export default CompareModal